import React from "react"
import { NavBar } from "../../Navbar"
import { HeaderSection } from "./HeaderSection"
import { LandingSection } from "./LandingSection"

export const Mobiliario = () => {
  const colorText = "white"
  const rutaTitle = "Soluciones"
  const title = ["Soluciones", ""]
  const classTitle = "mobiliario"
  const mainTitle = "Mobiliario"
  const logoBlanco = true
  return (
    <>
      <NavBar
        colorText={colorText}
        darkBackground={logoBlanco}
        classTitle={classTitle}
      />
      <section id="Mobiliario" className={`${classTitle}-section`}>
        <HeaderSection
          rutaTitle={rutaTitle}
          title={title}
          classTitle={classTitle}
        />
        <LandingSection classTitle={classTitle} mainTitle={mainTitle} />
      </section>
    </>
  )
}
